import { useCallback } from 'react';
import { useService } from '@atlassian/jira-common-services/src/use-service';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { ProjectId } from '@atlassian/jira-shared-types/src/general.tsx';

export type PrivacyConcern = 'USER_GENERATED_CONTENT';
export type Variable = {
	key: string;
	label: string;
	automationContext?: string;
	privacyConcerns: PrivacyConcern[];
};

export type VariableResponse = {
	variables: Variable[];
};

export type NotificationVariables = {
	availableVariables: VariableResponse[];
	safeNotificationSettingsEnabled: boolean;
};

export const useNotificationVariables = (projectId: ProjectId, ruleSetId: number) => {
	const variablesRequest = useCallback(
		() =>
			Promise.all([
				performGetRequest(
					`/rest/servicedesk/notifications/1/configuration/${projectId}/availableVariables?ruleSetId=${ruleSetId}`,
				),
				performGetRequest('/rest/servicedesk/admin/1/compliance/safe-notification-setting'),
			]).then((values) => ({
				safeNotificationSettingsEnabled: values[1]?.safeNotificationSetting === 'ENABLED',
				// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
				availableVariables: values[0] as VariableResponse[],
			})),
		[projectId, ruleSetId],
	);

	return useService<NotificationVariables>(variablesRequest);
};
